import { attr } from '@square/dashboard-data/utils/ember-model-stubs';
import BaseAddonsSettings from './base-addons-settings';
export default BaseAddonsSettings.extend({
  isDisabledInTransactionFlow: attr(Boolean, {
    defaultValue: false
  }),
  isAlwaysShowDisabled: attr(Boolean, {
    defaultValue: true
  }),
  isStarBackgroundDisabled: attr(Boolean, {
    defaultValue: true
  }),
  isRedeemRewardsInCheckoutDisabled: attr(Boolean, {
    defaultValue: true
  }),
  dismissTimerInterval: attr(Number, {
    defaultValue: 15
  })
});